import React from 'react';
import styled from 'styled-components';
import { FooterProps } from '../types';

const FooterContainer = styled.footer`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid var(--color-dark);
  padding-top: 2.4rem;
  padding-bottom: 1rem;
  margin-top: 2.4rem;

  @media (max-width: 576px) {
    flex-direction: column;
    gap: 1.6rem;
  }

  @media (max-width: 800px) {
    padding-bottom: 2rem;
  }
`;

const Footer: React.FC<FooterProps> = ({ children }) => {
  return <FooterContainer>{children}</FooterContainer>;
};

export default Footer;
